import { makeStyles, Paper, Theme, createStyles } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import Header from '../../../components/Header/Header';
import { APP_TITLE } from '../../../utils/constants';
import { GetString } from '../../../components/StringResourceManager';
import AlertsScheduledContainer from '../../../components/AlertsGrid/Scheduled/AlertsScheduledContainer';
import { getDivisionList } from '../../../store/Assets/AssetsActions';
import { useEffect } from 'react';
import { Dispatch } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paperGrid: {
      marginTop: theme.spacing(7),
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
    },
  }),
);

export default function AlertsScheduledSubMenu() {
  const classes = useStyles();

  const isLogin: boolean = useSelector(
    (state: ApplicationState) => state.userSessionReducer.isLoggedIn,
  );
  const dispatch: Dispatch<any> = useDispatch();

  useEffect(() => {
    if (isLogin) {
      getDivisionList(dispatch);
    }
    return () => {};
  }, [isLogin]);

  return (
    <>
      <Helmet>
        <title>
          {GetString('PAGE_TITLE_SCHEDULED_IMPORTS')} | {APP_TITLE}
        </title>
      </Helmet>
      <Header
        open={true}
        pageDisplayed={GetString('PAGE_TITLE_SCHEDULED_IMPORTS')}
      />
      <Paper className={classes.paperGrid}>
        <AlertsScheduledContainer />
      </Paper>
    </>
  );
}
